<template>
  <div name="hrms31e-index-search"  id="index-search-request">
    <!-- <div class="box-body"> -->
    <div class="detail-block">
      <div class="box-topic border-color-skin">
        <i class="fa fa-envelope margin-r-5 color-skin"></i>
        <label class="color-skin">{{ labels['HRPM31EP3']['10'] }}</label>
      </div>        
        
      <div class="row">
        <div class="col-xs-12 col-md-2"></div>
        <div class=" col-md-3 input-half-left">
          <div class="form-group">
            <label>{{ labels['HRPM31EP3']['20'] }} :</label>
            <hrms-datepicker v-model="p_dtest"
                             v-validate="'required|date_format:DD/MM/YYYY'"
                             data-vv-value-path="inputDate"
                             data-vv-name="dtest"
                             name="dtest" />
            <span v-show="errors.has('dtest')" class="text-error">{{ errors.first('dtest') }}</span>
          </div>
        </div>
        <div class=" col-md-3 input-half-left">
          <div class="form-group">
            <label>{{ labels['HRPM31EP3']['30'] }} :</label>
            <hrms-datepicker v-model="p_dteed"
                             v-validate="'required|date_format:DD/MM/YYYY|after:dtest'"
                             data-vv-value-path="inputDate"
                             data-vv-name="dteen"
                             name="dteen" />
            <span v-show="errors.has('dteen')" class="text-error">{{ errors.first('dteen') }}</span>
          </div>
        </div> 
        <div class="col-xs-12 col-md-2">
          <div class="form-group-button">
            <div class="btn button-in-search bg-color-skin" @click="callSearch()"><i class="fa fa-search"></i> {{ labelsButton['search'] }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'hrms31e-detail-search',
  data () {
    return {
      searchBoxDisp: true,
      p_dtest: this.dtest,
      p_dteed: this.dteen
    }
  },
  props: [ 'receivedHrms31eDetailSearch', 'labels', 'labelsButton', 'nowLang', 'setSaveButtonDisp', 'codempid', 'dtest', 'dteen' ],
  watch: {
    dtest () {
      this.p_dtest = this.dtest
    },
    dteen () {
      this.p_dteed = this.dteen
    }
  },
  methods: {
    searchParams () {
      return {
        p_codempid_query: this.codempid,
        p_dtest: this.p_dtest,
        p_dteed: this.p_dteed
      }
    },
    toggleSearchBox () {
      this.searchBoxDisp = !this.searchBoxDisp
    },
    callSearch () {
      this.$validator.validateAll().then(result => {
        this.receivedHrms31eDetailSearch(this.searchParams())
        this.setSaveButtonDisp(true)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// detail_search.vue?6f7f32bd